import { render, staticRenderFns } from "./NewPayAuthorityModal.vue?vue&type=template&id=3386e410&scoped=true&"
import script from "./NewPayAuthorityModal.vue?vue&type=script&lang=ts&"
export * from "./NewPayAuthorityModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewPayAuthorityModal.vue?vue&type=style&index=0&id=3386e410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386e410",
  null
  
)

export default component.exports